import React from 'react';

const HorizontalSpacer = () => <div className="mt-4" />;

export default HorizontalSpacer;
